(function () {
  'use strict';

  const drawer = document.querySelector('[data-native-cart-drawer]');
  if (!drawer) return;

  const popup = drawer.closest('popup-element');
  const itemsContainer = drawer.querySelector('[data-native-cart-items]');
  const scrollArea = drawer.querySelector('.native-cart-scroll');
  const recommendations = drawer.querySelector('[data-native-cart-recommendations-products]');
  const fallbackData = drawer.querySelector('[data-native-cart-fallback-products]');
  const curatedData = drawer.querySelector('[data-native-cart-curated-products]');
  const discountContainer = drawer.querySelector('[data-native-cart-discount-codes]');
  const recommendationLimit = Number(drawer.dataset.recommendationLimit || 4);
  const subscriptionUpgradeEnabled = drawer.dataset.subscriptionUpgradeEnabled !== 'false';
  let currentCart = null;
  let previousItemCount = null;
  let lastRecommendationKey = '';
  let requestInFlight = false;
  const productDataCache = new Map();

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function html(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD'
    }).format((Number(cents) || 0) / 100);
  }

  function openDrawer() {
    if (!popup) return;
    popup.open = true;
    window.setTimeout(function () {
      const close = drawer.querySelector('.ajaxcart__header-close button');
      if (close) close.focus();
    }, 50);
  }

  function visibleItems(cart) {
    return (cart.items || []).filter(function (item) {
      const properties = item.properties || {};
      return !properties._child_bundle_product && !properties._child_soft_bundle;
    });
  }

  function lineDiscounts(item) {
    return (item.line_level_discount_allocations || []).map(function (allocation) {
      return allocation.discount_application && allocation.discount_application.title;
    }).filter(Boolean).filter(function (title, index, titles) {
      return titles.indexOf(title) === index;
    });
  }

  function itemProperties(item) {
    const properties = item.properties || {};
    return Object.keys(properties).filter(function (name) {
      return name.charAt(0) !== '_' && properties[name] !== '' && properties[name] != null;
    }).map(function (name) {
      return '<span>' + html(name) + ': ' + html(properties[name]) + '</span>';
    }).join('');
  }

  function sellingPlan(item) {
    if (item.selling_plan_allocation) {
      const plan = item.selling_plan_allocation.selling_plan;
      return '<div class="native-cart-item__selling-plan"><select data-native-cart-selling-plan ' +
        'data-line-key="' + html(item.key) + '" data-product-url="' + html(item.url) + '" ' +
        'data-variant-id="' + html(item.variant_id) + '" data-current-plan="' + html(plan.id) + '" ' +
        'aria-label="Delivery frequency for ' + html(item.product_title) + '">' +
        '<option value="' + html(plan.id) + '">' + html(plan.name) + '</option></select></div>';
    }

    if (!subscriptionUpgradeEnabled) return '';

    return '<div class="native-cart-item__subscription-upgrade" data-native-cart-subscription-upgrade ' +
      'data-line-key="' + html(item.key) + '" data-product-url="' + html(item.url) + '" ' +
      'data-variant-id="' + html(item.variant_id) + '" hidden></div>';
  }

  function cartItem(item) {
    const discounted = Number(item.final_line_price) < Number(item.original_line_price);
    const discounts = lineDiscounts(item);
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="native-cart-item__variant">' + html(item.variant_title) + '</div>' : '';
    const image = item.image
      ? '<a class="native-cart-item__image" href="' + html(item.url) + '"><img src="' + html(item.image) +
        '" alt="' + html(item.product_title) + '" loading="lazy" width="150" height="180"></a>' : '';

    return '<article class="native-cart-item" data-line-key="' + html(item.key) + '">' + image +
      '<div class="native-cart-item__details">' +
        '<button class="native-cart-item__remove" type="button" data-native-cart-remove data-line-key="' +
          html(item.key) + '" aria-label="Remove ' + html(item.product_title) + '"><span aria-hidden="true">×</span></button>' +
        '<a class="native-cart-item__title" href="' + html(item.url) + '">' + html(item.product_title) + '</a>' +
        variant +
        (discounts.length ? '<div class="native-cart-item__line-discounts">' + discounts.map(html).join(', ') + '</div>' : '') +
        '<div class="native-cart-item__properties">' + itemProperties(item) + '</div>' +
        '<div class="native-cart-item__controls">' +
          '<div class="native-cart-quantity" aria-label="Quantity">' +
            '<button type="button" data-native-cart-quantity="' + (item.quantity - 1) + '" data-line-key="' + html(item.key) + '" aria-label="Decrease quantity">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-native-cart-quantity="' + (item.quantity + 1) + '" data-line-key="' + html(item.key) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<div class="native-cart-item__price' + (discounted ? ' is-discounted' : '') + '">' +
            '<span class="native-cart-item__final-price">' + money(item.final_line_price) + '</span>' +
            (discounted ? '<s>' + money(item.original_line_price) + '</s>' : '') +
          '</div>' +
        '</div>' + sellingPlan(item) +
      '</div></article>';
  }

  function renderItems(cart) {
    if (!itemsContainer) return;
    itemsContainer.innerHTML = visibleItems(cart).map(cartItem).join('');
    hydrateSellingPlanControls();
  }

  function updateTotals(cart) {
    document.querySelectorAll('[data-cart-indicator]').forEach(function (indicator) {
      indicator.classList.toggle('d-none', cart.item_count === 0);
    });
    drawer.querySelectorAll('cart-count').forEach(function (count) { count.textContent = cart.item_count; });
    drawer.querySelectorAll('cart-total').forEach(function (total) { total.textContent = money(cart.total_price); });
  }

  function renderDiscounts(cart) {
    if (!discountContainer) return;
    const applications = cart.cart_level_discount_applications || [];
    discountContainer.innerHTML = applications.map(function (application) {
      const amount = Number(application.total_allocated_amount || 0);
      return '<div class="native-cart-discount-row"><span class="native-cart-discount">' +
        '<span class="native-cart-discount__tag" aria-hidden="true"></span>' + html(application.title) + '</span>' +
        '<span>' + (amount ? '-' + money(amount) : 'Code Applied In Checkout') + '</span></div>';
    }).join('');
    discountContainer.hidden = applications.length === 0;
  }

  function updateShipping(cart) {
    const holder = drawer.querySelector('[data-fsb]');
    if (!holder) return;
    const threshold = Number(holder.dataset.fsb || 0) * 100;
    const subscription = (cart.items || []).some(function (item) { return Boolean(item.selling_plan_allocation); });
    const qualifies = subscription || cart.total_price >= threshold;
    const bar = holder.querySelector('[data-fsb-bar]');
    const label = holder.querySelector('[data-fsb-text]');
    if (bar) bar.style.width = (qualifies || !threshold ? 100 : Math.min(100, cart.total_price / threshold * 100)) + '%';
    if (label) {
      label.innerHTML = qualifies ? label.dataset.qualifiedText :
        label.dataset.unqualifiedText.replace(/\[amount\]/g, money(Math.max(0, threshold - cart.total_price)));
    }
    drawer.querySelectorAll('show-if-cart-over[data-threshold]').forEach(function (row) {
      row.classList.toggle('hide', !qualifies);
    });
    drawer.dataset.freeShippingQualified = qualifies ? 'true' : 'false';
    drawer.dataset.freeShippingReason = subscription ? 'subscription' : (qualifies ? 'threshold' : 'unqualified');
  }

  function normalizeProduct(product) {
    return {
      id: Number(product.id), title: product.title, handle: product.handle,
      url: product.url || (product.handle ? root() + 'products/' + product.handle : '#'),
      image: product.featured_image && (product.featured_image.url || product.featured_image.src || product.featured_image),
      price: Number(product.price_min != null ? product.price_min : product.price),
      variants: (product.variants || []).filter(function (variant) { return variant.available !== false; })
    };
  }

  function fallbackProducts() {
    if (!fallbackData) return [];
    try { return JSON.parse(fallbackData.textContent || '[]').map(normalizeProduct); }
    catch (error) { console.error('Native cart fallback products could not be parsed.', error); return []; }
  }

  function curatedProducts() {
    if (!curatedData) return [];
    try { return JSON.parse(curatedData.textContent || '[]').map(normalizeProduct); }
    catch (error) { console.error('Native cart curated products could not be parsed.', error); return []; }
  }

  function productCard(product) {
    const variant = product.variants && product.variants[0];
    if (!variant) return '';
    const options = product.variants.map(function (item) {
      return '<option value="' + html(item.id) + '" data-price="' + html(item.price) + '">' + html(item.title) + '</option>';
    }).join('');
    return '<article class="native-cart-recommendation" data-native-cart-recommendation>' +
      (product.image ? '<a class="native-cart-recommendation__image" href="' + html(product.url) +
        '"><img src="' + html(product.image) + '" alt="' + html(product.title) + '" loading="lazy" width="180" height="220"></a>' : '') +
      '<a class="native-cart-recommendation__title" href="' + html(product.url) + '">' + html(product.title) + '</a>' +
      '<span class="native-cart-recommendation__price" data-native-cart-recommendation-price>' +
        money(variant.price != null ? variant.price : product.price) + '</span>' +
      (product.variants.length > 1
        ? '<select class="native-cart-recommendation__variant" aria-label="Choose ' + html(product.title) + ' option">' + options + '</select>'
        : '<input class="native-cart-recommendation__variant" type="hidden" value="' + html(variant.id) + '">') +
      '<button class="native-cart-recommendation__add" type="button" data-native-cart-recommendation-add>Add</button></article>';
  }

  function renderRecommendations(products) {
    if (!recommendations) return;
    const inCart = (currentCart && currentCart.items || []).map(function (item) { return Number(item.product_id); });
    const unique = [];
    products.forEach(function (product) {
      const item = product.variants ? product : normalizeProduct(product);
      if (!item.id || inCart.includes(item.id) || !item.variants.length) return;
      if (!unique.some(function (existing) { return existing.id === item.id; })) unique.push(item);
    });
    recommendations.innerHTML = unique.slice(0, recommendationLimit).map(productCard).join('');
    const section = drawer.querySelector('[data-native-cart-recommendations]');
    if (section) section.hidden = unique.length === 0;
  }

  async function recommendationProducts(productId, intent) {
    const response = await fetch(root() + 'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) + '&limit=8&intent=' + intent, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Recommendation request failed');
    const payload = await response.json();
    return (payload.products || []).map(normalizeProduct);
  }

  async function updateRecommendations(cart) {
    if (!recommendations) return;
    const items = visibleItems(cart);
    const curated = curatedProducts();
    const productId = items[0] && items[0].product_id;
    const cartProductKey = items.map(function (item) { return item.product_id; }).join(',');
    const key = curated.length
      ? 'curated:' + curated.map(function (product) { return product.id; }).join(',') + ':' + cartProductKey
      : (productId ? productId + ':' + cartProductKey : 'empty');
    if (key === lastRecommendationKey) return;
    lastRecommendationKey = key;
    if (curated.length) {
      renderRecommendations(curated);
      return;
    }
    if (!productId) { renderRecommendations(fallbackProducts()); return; }
    try {
      let products = await recommendationProducts(productId, 'complementary');
      if (products.length < recommendationLimit) products = products.concat(await recommendationProducts(productId, 'related'));
      renderRecommendations(products.concat(fallbackProducts()));
    } catch (error) {
      console.error('Native cart recommendations could not be loaded.', error);
      renderRecommendations(fallbackProducts());
    }
  }

  async function fetchProductData(productUrl) {
    const path = new URL(productUrl, window.location.origin).pathname.replace(/\.js$/, '');
    if (!productDataCache.has(path)) {
      productDataCache.set(path, fetch(path + '.js', { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Product selling plans could not be loaded');
        return response.json();
      }));
    }
    return productDataCache.get(path);
  }

  function plansForVariant(product, variantId) {
    const variant = (product.variants || []).find(function (item) {
      return String(item.id) === String(variantId);
    });
    const allowedPlanIds = (variant && variant.selling_plan_allocations || []).map(function (allocation) {
      return String(allocation.selling_plan_id);
    });
    const plans = [];
    (product.selling_plan_groups || []).forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) {
        if (allowedPlanIds.includes(String(plan.id)) &&
            !plans.some(function (existing) { return String(existing.id) === String(plan.id); })) {
          plans.push(plan);
        }
      });
    });
    return plans;
  }

  function planSavings(plan) {
    const adjustment = plan && plan.price_adjustments && plan.price_adjustments[0];
    return adjustment && adjustment.value_type === 'percentage' ? Number(adjustment.value) : 0;
  }

  function hydrateSellingPlanControls() {
    drawer.querySelectorAll('[data-native-cart-selling-plan]').forEach(async function (select) {
      if (!select.dataset.productUrl || select.dataset.hydrated === 'true') return;
      select.dataset.hydrated = 'true';
      try {
        const product = await fetchProductData(select.dataset.productUrl);
        const plans = plansForVariant(product, select.dataset.variantId);
        if (plans.length) {
          select.innerHTML = '<option value="">One-time only</option>' + plans.map(function (plan) {
            return '<option value="' + html(plan.id) + '"' +
              (String(plan.id) === String(select.dataset.currentPlan) ? ' selected' : '') + '>' + html(plan.name) + '</option>';
          }).join('');
        }
      } catch (error) { console.error('Selling plan options could not be loaded.', error); }
    });

    drawer.querySelectorAll('[data-native-cart-subscription-upgrade]').forEach(async function (holder) {
      if (!holder.dataset.productUrl || holder.dataset.hydrated === 'true') return;
      holder.dataset.hydrated = 'true';
      try {
        const product = await fetchProductData(holder.dataset.productUrl);
        const plans = plansForVariant(product, holder.dataset.variantId);
        if (!plans.length) return;
        const savings = planSavings(plans[0]);
        holder.innerHTML = '<button type="button" data-native-cart-upgrade data-line-key="' +
          html(holder.dataset.lineKey) + '" data-selling-plan="' + html(plans[0].id) + '">' +
          'Upgrade to Subscription' + (savings ? ' &amp; Save ' + savings + '%' : '') + '</button>';
        holder.hidden = false;
      } catch (error) { console.error('Subscription upgrade could not be loaded.', error); }
    });
  }

  function handleCart(cart, shouldOpen) {
    const increased = previousItemCount !== null && cart.item_count > previousItemCount;
    previousItemCount = cart.item_count;
    currentCart = cart;
    renderItems(cart);
    updateTotals(cart);
    renderDiscounts(cart);
    updateShipping(cart);
    updateRecommendations(cart);
    if (shouldOpen || increased) openDrawer();
  }

  async function refreshCart(shouldOpen) {
    const response = await fetch(root() + 'cart.js', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh cart');
    const cart = await response.json();
    window.dispatchEvent(new CustomEvent('cartAPI', {
      detail: { cartData: cart, nativeCartHandled: true }
    }));
    handleCart(cart, shouldOpen);
    return cart;
  }

  async function changeLine(key, quantity, plan) {
    if (requestInFlight) return;
    requestInFlight = true;
    try {
      const body = { id: key };
      if (quantity != null) body.quantity = Math.max(0, Number(quantity));
      if (quantity == null && plan != null && currentCart) {
        const existingItem = (currentCart.items || []).find(function (item) { return item.key === key; });
        if (existingItem) body.quantity = existingItem.quantity;
      }
      if (plan != null) body.selling_plan = plan === '' ? null : Number(plan);
      const response = await fetch(root() + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('Unable to update cart');
      await refreshCart(false);
    } catch (error) { console.error(error); }
    finally { requestInFlight = false; }
  }

  drawer.addEventListener('wheel', function (event) {
    if (!scrollArea || !event.deltaY || event.ctrlKey || event.metaKey) return;
    const maximum = scrollArea.scrollHeight - scrollArea.clientHeight;
    if (maximum <= 0) return;
    const multiplier = event.deltaMode === 1 ? 16 : (event.deltaMode === 2 ? scrollArea.clientHeight : 1);
    const next = Math.min(maximum, Math.max(0, scrollArea.scrollTop + event.deltaY * multiplier));
    if (next === scrollArea.scrollTop) return;
    event.preventDefault();
    scrollArea.scrollTop = next;
  }, { passive: false });

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    const action = form && form.getAttribute && form.getAttribute('action');
    if (!action || action.indexOf('/cart/add') === -1 || form.dataset.nativeCartSubmitting === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.dataset.nativeCartSubmitting = 'true';
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.disabled = true;
    try {
      const data = new FormData(form);
      if (event.submitter && event.submitter.name && !data.has(event.submitter.name)) {
        data.append(event.submitter.name, event.submitter.value);
      }
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', body: data,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) {
        const payload = await response.json();
        throw new Error(payload.description || payload.message || 'Unable to add item');
      }
      await refreshCart(true);
    } catch (error) {
      console.error(error);
      window.alert(error.message || 'This item could not be added to your cart.');
    } finally {
      delete form.dataset.nativeCartSubmitting;
      if (submitter) submitter.disabled = false;
    }
  }, true);

  document.addEventListener('click', function (event) {
    const open = event.target.closest('[data-native-cart-open]');
    if (open) { event.preventDefault(); openDrawer(); return; }
    const quantity = event.target.closest('[data-native-cart-quantity]');
    if (quantity) { changeLine(quantity.dataset.lineKey, quantity.dataset.nativeCartQuantity); return; }
    const remove = event.target.closest('[data-native-cart-remove]');
    if (remove) { changeLine(remove.dataset.lineKey, 0); return; }
    const upgrade = event.target.closest('[data-native-cart-upgrade]');
    if (upgrade) {
      const originalLabel = upgrade.textContent;
      upgrade.disabled = true;
      upgrade.textContent = 'Upgrading…';
      changeLine(upgrade.dataset.lineKey, null, upgrade.dataset.sellingPlan).then(function () {
        if (document.documentElement.contains(upgrade)) {
          upgrade.disabled = false;
          upgrade.textContent = originalLabel;
        }
      });
      return;
    }

    const button = event.target.closest('[data-native-cart-recommendation-add]');
    if (!button) return;
    const card = button.closest('[data-native-cart-recommendation]');
    const variant = card && card.querySelector('.native-cart-recommendation__variant');
    if (!variant || !variant.value) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    fetch(root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (payload) {
        throw new Error(payload.description || 'Unable to add item');
      });
      return refreshCart(true);
    }).catch(function (error) {
      console.error(error);
      button.textContent = 'Try again';
    }).finally(function () {
      button.disabled = false;
      if (button.textContent !== 'Try again') button.textContent = 'Add';
    });
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.native-cart-recommendation__variant')) {
      const option = event.target.options[event.target.selectedIndex];
      const price = event.target.closest('[data-native-cart-recommendation]').querySelector('[data-native-cart-recommendation-price]');
      if (price && option && option.dataset.price) price.textContent = money(option.dataset.price);
    }
    if (event.target.matches('[data-native-cart-selling-plan]')) {
      changeLine(event.target.dataset.lineKey, null, event.target.value);
    }
  });

  window.addEventListener('cartAPI', function (event) {
    if (event.detail && event.detail.nativeCartHandled) return;
    const cart = event.detail && event.detail.cartData;
    if (cart) handleCart(cart, false);
  });

  const cartRedirect = new URLSearchParams(window.location.search).has('cart_redirect');
  refreshCart(cartRedirect).then(function () {
    if (!cartRedirect || !window.history || !window.history.replaceState) return;
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('cart_redirect');
    window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
  }).catch(function (error) {
    console.error('Native cart could not be initialized.', error);
  });
})();
